(function($) {

    $(document).ready(function () {

        if ($('.partners-swiper').length) {
            var partnersSlider = new Swiper ('.partners-swiper', {
                autoHeight: true,
                allowTouchMove: false,
                slidesPerView: 1,
                speed: 0,
                effect: 'fade',
                fadeEffect: {
                    crossFade: true
                },
                breakpoints: {
                    // when window width is >= 1000
                    1000: {
                        speed: 600
                    }
                }
            });

            $('.partners-section .icon-wrap').on('click', function() {
                var $this = $(this);

                $this.siblings().removeClass('active');
                $this.addClass('active');

                partnersSlider.slideTo($this.data('slide-index'));

                // setTimeout(function() {
                    $('.partners-swiper').removeClass('mobile-hidden');
                // }, 300);
            });

            $('.partners-swiper .close-btn').on('click', function() {
                $('.partners-swiper').addClass('mobile-hidden');
            });

        }

        $(window).on('load', function() {
            if ($(window).width() <= 1000) {
                $('.partners-section .icon-wrap').removeClass('active');
            }
        });

        $(window).on('resize', function () {
            if ($(window).width() <= 1000) {
                $('.partners-section .icon-wrap').removeClass('active');
            }
        });


    });

})( jQuery );